<template>
  <div
    :id="fieldkey + '_map'"
    ref="basicMapbox"
    :style="mapSize"
  />
</template>
<script>
import axios from 'axios'
export default {
  props: {
    mapWidth: {
      type: [String, Number],
      default: ''
    },
    mapHeight: {
      type: [String, Number],
      default: ''
    },
    lat: {
      type: [String, Number],
      default: ''
    },
    lng: {
      type: [String, Number],
      default: ''
    },
    countryCode: {
      type: String,
      default: ''
    },
    level: {
      type: [String, Number],
      default: 3
    },
    fieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      map: null,
      urlTemplate: {
        ChinaOnlineCommunity_Mobile: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer',
        ChinaOnlineCommunity: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineCommunity/MapServer',
        ChinaOnlineCommunityENG: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineCommunityENG/MapServer',
        ChinaOnlineStreetPurplishBlue: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer',
        ChinaOnlineStreetWarm: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetWarm/MapServer',
        ChinaOnlineStreetGray: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetGray/MapServer'
      }
    }
  },
  computed: {
    mapSize () {
      let styleObj = {
        width: this.mapWidth,
        height: this.mapHeight
      }
      return styleObj
    }
  },
  async mounted () {
    await this.getSource()
  },
  destroyed () {
    this.map = null
  },
  methods: {
    init () {
      this.map = window.L.map(this.fieldkey + '_map', {
        center: [this.lat, this.lng],
        zoom: this.level + 3,
        minZoom: 2,
        maxZoom: 18
      })
      window.L.esri.tiledMapLayer({
        url: this.urlTemplate.ChinaOnlineStreetWarm
      }).addTo(this.map)

      /* window.L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
        maxZoom: 18,
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        id: 'mapbox/streets-v11'
      }).addTo(map) */
      /*  window.L.esri.tiledMapLayer(this.urlTemplate.SYS_CQMap_VEC_MAPSERVER_PATH, {
        maxZoom: 17,
        minZoom: 2
      }).addTo(map) */
      /* window.L.tileLayer.provider('MapBox', {
        // 这里请换成自己的
        accessToken: 'pk.eyJ1IjoiYW55YW5hbiIsImEiOiJjazRqbjZ4dWYwODlxM2pxaTNkM2V1eW9zIn0.7FnZc2UlCnoijDfL5r8yfA',
        id: 'map'
      }).addTo(map) */
      // Thunderforest
      // window.L.tileLayer.provider('Thunderforest.Landscape', { apikey: '<insert api_key here>' }).addTo(map)
      // Stamen
      // window.L.tileLayer.provider('Stamen.Watercolor').addTo(map)

      // window.L.marker([34.72468, 113.6401]).addTo(map)  // 33.52222 -86.79972
      window.L.marker([this.lat, this.lng]).addTo(this.map)
    },
    async getSource () {
      await axios.get('https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetWarm/MapServer/?f=json').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.init()
        }
      })
    }
  }
}
</script>
